<template>
  <div class="int-vacancy-item">
    <VCheckbox
      v-model="checked"
      hide-details=""
      class="int-vacancy-name"
    >
      <template v-slot:label>
        <label class="int-vacancy-label">
          {{ vacancy.title }}
          <a
            :href="`https://rabota.ru/vacancy/${vacancy.id}/`"
            target="_blank"
            class="ml-2 text-decoration-none"
            style="position: relative; z-index: 2"
          >
            <VIcon small>
              mdi-open-in-new
            </VIcon>
          </a>
          <div class="int-vacancy-id"><span>ID: </span>{{ vacancy.id }}</div>
        </label>
      </template>
    </VCheckbox>
    <div class="int-vacancy-city">
      {{ text }}
    </div>
    <div class="int-vacancy-pay">
      <VacancySalary :salary="vacancy.salary" />
    </div>
  </div>
</template>

<script>
import {
  computed, toRefs, watch, ref,
} from '@vue/composition-api';
import VacancySalary from '@/components/Vacancy/VacancySalary';

export default {
  name: 'IntegrationsVacancyListItem',
  components: { VacancySalary },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    selected: Boolean,
  },
  setup(props, { emit }) {
    const { vacancy, selected } = toRefs(props);
    const checked = ref(false);

    watch(selected, () => {
      checked.value = selected.value;
    }, {
      immediate: true,
    });

    watch(checked, (val) => {
      emit(val ? 'add' : 'remove', vacancy.value.id);
    });

    const text = computed(() => vacancy.value.cities.filter((v) => !!v).join(', '));

    return {
      text,
      checked,
    };
  },
};
</script>

<style lang="scss" scoped>

  .d-flex {
    display: flex;
    align-items: center;
  }

  .int-vacancy-item {
    display: flex;
    padding: 0.4375rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 0.9375rem;
    color: #091A35;
  }
  .int-vacancy-name {
    flex-grow: 2 !important;
    .int-vacancy-label {
      color: #091A35;
    }
  }
  .int-vacancy-id {
    font-size: 0.6875rem;
    color: rgba(9, 26, 53, 0.5);
  }
  .int-vacancy-city {
    color: rgba(9, 26, 53, 0.5);
    min-width: 11.75rem;
    max-width: 11.75rem;
    padding: 0 1rem;
  }
  .int-vacancy-pay {
    min-width: 9rem;
    max-width: 9rem;
    color: rgba(9, 26, 53, 0.5);
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .int-vacancy-label, .int-vacancy-item-text {
      font-size: 1rem;
    }
    .int-vacancy-pay {
      min-width: 4.5rem;
      max-width: 4.5rem;
      color: rgba(9, 26, 53, 0.5);
    }
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .int-vacancy-item {
      display: block;
    }
    .int-vacancy-city, .int-vacancy-pay {
      width: 100%;
      min-width: inherit;
      max-width: inherit;
      padding: 0 1rem 0 2rem;
    }
  }

</style>
